import FindConversationJsonResponse from 'owa-service/lib/contract/FindConversationJsonResponse';
import { getItemFromSessionStorage, setItemInSessionStorage } from 'mini-session-storage';

const CONVERSATION_LIST_SESSION_STORAGE_KEY = 'findConversation';

export function getFindConversationDataFromSessionStorage() {
    return getItemFromSessionStorage(CONVERSATION_LIST_SESSION_STORAGE_KEY);
}

export function setFindConversationDataInSessionStorage(
    findConversationData: FindConversationJsonResponse
) {
    return setItemInSessionStorage(CONVERSATION_LIST_SESSION_STORAGE_KEY, findConversationData);
}
